import { Controller } from "stimulus";
import MicroModal from "micromodal";

export default class extends Controller {
  static targets = ["column", "name", "steps", "actions", "modal", "stars", "currentBalance"];
  gameId;
  cardItems = [];
  hasFlippedCard = false;
  firstCard;
  secondCard;
  lockBoard = true;
  steps = 0;
  config = {
    1: 40,
    2: 30,
    3: 20,
  };

  connect() {
    this.gameId = document.querySelector("#game-id").value;
    this.startButton = document.getElementById("start_button");
    this.startButton.disabled = false
    this.starsColor(3);
  }

  prizeModal() {
    MicroModal.show("prize-modal");
  }

  starsColor(num = 0) {
    const ch = Array.prototype.slice.call(this.starsTarget.children);
    ch.forEach((el, i) => {
      if (i < num) {
        el.style.color = "#ffbc0d";
      } else {
        el.style.color = "inherit";
      }
    });
  }

  flipCard(ev) {
    ev.preventDefault();
    if (this.lockBoard) return;
    if (ev.target === this.firstCard) return;

    ev.target.classList.add("flip");

    if (!this.hasFlippedCard) {
      this.hasFlippedCard = true;
      this.firstCard = ev.target;

      return;
    }

    this.steps++;
    this.stepsTarget.textContent = this.steps;

    this.secondCard = ev.target;

    this.checkForMatch();

    if (this.isEndGame()) {
      this.finishGame();
    }
  }

  winRateModal(html) {
    var title = document.getElementById("you-won-title").value
    this.showModal(title, html, (modal) => {
      this.lockBoard = true;
      this.actionsTarget.classList.remove("started");
      this.unFlip();
      this.steps = 0;
      this.stepsTarget.textContent = this.steps;
      this.starsColor(3);
    })
  }

  loseModal() {
    MicroModal.show("lose-modal", {
      onClose: (modal) => {
        this.lockBoard = true;
        this.actionsTarget.classList.remove("started");
        this.unFlip();
        this.steps = 0;
        this.stepsTarget.textContent = this.steps;
        this.starsColor(3);
      },
    });
  }

  setImageCards() {
    this.columnTargets.forEach((el, colIdx) => {
      const ch = Array.prototype.slice.call(el.children);
      ch.forEach((el, rowIdx) => {
        el.childNodes[3].firstElementChild.src = this.cardItems[colIdx][rowIdx]
      });
    });
  }

  isEndGame() {
    return this.columnTargets.every((el, colIdx) => {
      const ch = Array.prototype.slice.call(el.children);
      return ch.every((el, rowIdx) => el.disabled);
    });
  }

  unFlip() {
    this.columnTargets.forEach((el, colIdx) => {
      const ch = Array.prototype.slice.call(el.children);
      ch.forEach((el, rowIdx) => {
        setTimeout(() => {
          el.classList.remove("flip");
          el.disabled = false;
        }, rowIdx * 100);
      });
    });
  }

  startGame() {
    this.startButton.disabled = true
    this.postData(`/web/games/memory?id=${this.gameId}`).then((response) => {
      if (response.error) {
        this.showModal('Sorry', response.error, null);
        // disabled false
        this.startButton.disabled = false;
      } else {
        this.cardItems = response.board;
        this.setImageCards();
        this.actionsTarget.classList.add("started");
        this.lockBoard = false;
        this.setCurrentBalance(response.balance);
      }
    });
    // setTimeout(function(){
    //   this.startButton.disabled = false;
    // }, 2000);
  }

  checkForMatch() {
    if (this.steps < this.config[3]) {
      this.starsColor(3);
    } else if (this.steps < this.config[2]) {
      this.starsColor(2);
    } else if (this.steps < this.config[1]) {
      this.starsColor(1);
    } else if (this.steps >= 40) {
      this.loseModal();
      return;
    }

    let isMatch =
      this.cardItems[this.firstCard.getAttribute("data-memory-game-col-param")][
        this.firstCard.getAttribute("data-memory-game-row-param")
      ] ===
      this.cardItems[
        this.secondCard.getAttribute("data-memory-game-col-param")
      ][this.secondCard.getAttribute("data-memory-game-row-param")];

    isMatch ? this.disableCards() : this.unflipCards();
  }

  disableCards() {
    this.firstCard.disabled = true;
    this.secondCard.disabled = true;

    this.resetBoard();
  }

  unflipCards() {
    this.lockBoard = true;

    const firstCard = this.firstCard;
    const secondCard = this.secondCard;

    setTimeout(() => {
      firstCard.classList.remove("flip");
      secondCard.classList.remove("flip");

      this.resetBoard();
    }, 500);
  }

  finishGame() {
    // disabled false
    this.startButton.disabled = false;
    fetch(`/web/games/memory/reward?id=${this.gameId}&steps=${this.steps}`, {method: "POST"})
      .then((response) => response.text())
      .then(html => {
        this.winRateModal(html);
      });
    Adjust.trackEvent({
      eventToken: "partner_profile_memorygame_finished"
    });
    if (this.steps < this.config[3]) {
      Adjust.trackEvent({
        eventToken: "won_three_stars_memory"
      });
    } else if (this.steps < this.config[2]) {
      Adjust.trackEvent({
        eventToken: "won_two_stars_memory"
      });
    } else if (this.steps < this.config[1]) {
      Adjust.trackEvent({
        eventToken: "won_one_star_memory"
      });
    } 
  }

  async postData(url = "", data = {}) {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data),
    });

    return await response.json();
  }

  resetBoard() {
    [this.hasFlippedCard, this.lockBoard] = [false, false];
    [this.firstCard, this.secondCard] = [null, null];
  }

  setCurrentBalance(v) {
    this.currentBalanceTarget.innerText = v.toString();
  }

  showModal(title, message, onClose) {
    this.modalTarget.querySelector(".header h2").innerHTML = title;
    this.modalTarget.querySelector(".content").innerHTML = message;
    if (onClose) {
      MicroModal.show("memory-game-modal", {onClose: onClose});
    } else {
      MicroModal.show("memory-game-modal");
    }
  }
}
